import _ from 'lodash';
import angular from 'angular';
import {CANDIDATE_FEEDBACK_STATUSES, EMPLOYER_STATUS_REASONS} from '../../../../recruiter/constants/feedback';

export const AUTO_FETCH_FEEDBACK_REASON = 'Auto-Fetch by Bot';

export const CandidateFitTooltipService = () => {
    const getSampleVisibleState = (candidate) => {
        return (!!candidate.sample) && (candidate.sample.nonRated) && (!getUnSelectedSampleVisibleState(candidate));
    };

    const getUnSelectedSampleVisibleState = (candidate) => {
        return !!candidate.unselectedSample;
    };

    const getGoodPreliminaryFeedbackVisibleState = ({sample}) => {
        return sample && sample.isGoodFeedback && (!sample.nonRated);
    };

    const getBadPreliminaryFeedbackVisibleState = ({sample}) => {
        return sample && (!sample.isGoodFeedback) && (!sample.nonRated);
    };

    const getGoodFitVisibilityState = (candidate) => {
        const grade = getFeedbackGrade(candidate);

        return grade === 1;
    };

    const getBadFitVisibilityState = (candidate) => {
        const grade = getFeedbackGrade(candidate);

        return grade === 0;
    };

    const getPendingVisibilityState = (candidate) => {
        const feedbackStatus = getFeedbackStatus(candidate);

        return feedbackStatus === CANDIDATE_FEEDBACK_STATUSES.PENDING;
    };

    const getReadyForSendVisibilityState = (candidate) => {
        const feedbackStatus = getFeedbackStatus(candidate);

        return feedbackStatus === CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND;
    };

    const getEmployerBackToFullServiceVisibilityState = (candidate) => {
        const employerStatusReason = _.get(candidate, 'workflow.employerStatus.reason');

        return employerStatusReason === EMPLOYER_STATUS_REASONS.EMPLOYER_BACK_TO_FULL_SERVICE;
    };

    const getFeedbackGrade = (candidate) => {
        const feedback = getFeedbackFromCandidate(candidate);

        return _.get(feedback, 'grades.0.grade', null);
    };

    const getFeedbackStatus = (candidate) => {
        const feedback = getFeedbackFromCandidate(candidate);

        return _.get(feedback, 'status', null);
    };

    const getFeedbackFromCandidate = (candidate) => {
        return _.get(candidate, 'workflow.feedback')
            || _.get(candidate, 'feedback')
            || _.get(candidate, 'sample');
    };

    const getFeedbackDate = (candidate) => {
        const feedback = getFeedbackFromCandidate(candidate);

        if (feedback && feedback.timestamp) {
            // eslint-disable-next-line no-undef
            const dateFormatter = new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            });

            return dateFormatter.format(new Date(feedback.timestamp));
        }

        return null;
    };

    const getFeedbackProviderName = (candidate) => {
        return _.get(candidate, 'feedback.feedbackProviderName')
            || _.get(candidate, 'workflow.feedback.feedbackProviderName')
            || _.get(candidate, 'sample.feedbackProviderName');
    };

    const getAutoFetchCandidateState = (candidate) => {
        const feedback = getFeedbackFromCandidate(candidate);
        const grade = getFeedbackGrade(candidate);
        const isAutoFetchReason = _.get(feedback, 'grades.0.reasons', []).includes(AUTO_FETCH_FEEDBACK_REASON);

        return grade === 1 && isAutoFetchReason;
    };

    return {
        getSampleVisibleState,
        getUnSelectedSampleVisibleState,
        getGoodPreliminaryFeedbackVisibleState,
        getBadPreliminaryFeedbackVisibleState,
        getGoodFitVisibilityState,
        getBadFitVisibilityState,
        getPendingVisibilityState,
        getReadyForSendVisibilityState,
        getEmployerBackToFullServiceVisibilityState,
        getFeedbackGrade,
        getFeedbackStatus,
        getFeedbackFromCandidate,
        getFeedbackDate,
        getFeedbackProviderName,
        getAutoFetchCandidateState,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CandidateFitTooltipService', CandidateFitTooltipService);
